import "core-js/modules/es.array.push.js";
import { queryWaitMeApplys } from '@/services/form';
var columns = [{
  title: '表单名称',
  dataIndex: 'formName',
  key: 'formName'
},
// {
//   title: '流水号',
//   dataIndex: 'description',
//   scopedSlots: { customRender: 'description' }
// },
{
  title: '发起时间',
  dataIndex: 'createTime',
  key: 'createTime'
}, {
  title: '当前节点',
  dataIndex: 'taskName',
  key: 'taskName'
},
// {
//   title: '状态',
//   dataIndex: 'updatedAt2',
//   sorter: true
// },
{
  title: '操作',
  key: 'action',
  scopedSlots: {
    customRender: 'action'
  }
}];
export default {
  name: 'WaitMeApply',
  components: {},
  data: function data() {
    return {
      advanced: true,
      columns: columns,
      dataSource: [],
      selectedRows: [],
      total: 0,
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        total: this.total,
        pageSizeOptions: ['5', '10', '20', '30', '40', '100'],
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        onShowSizeChange: this.pageSizeChange,
        onChange: this.pageChange
      },
      form: {
        pageSize: 10,
        currentNo: 1
      }
    };
  },
  authorize: {
    deleteRecord: 'delete'
  },
  methods: {
    toggleAdvanced: function toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClicWaitMeApplyList(); //获取列表数据
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClicWaitMeApplyList(); //获取列表数据
    },
    onClicWaitMeApplyList: function onClicWaitMeApplyList() {
      var _this = this;
      queryWaitMeApplys(this.form).then(function (res) {
        var data = res.data.data;
        _this.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
        _this.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
        _this.pagination.total = _this.total;
      });
    },
    loadData: function loadData() {
      this.onClicWaitMeApplyList();
    },
    onViewWaitMeApply: function onViewWaitMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.procInsId
        }
      });
    },
    applyAudit: function applyAudit(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/auditProcess',
        query: {
          procInsId: record.procInsId,
          taskId: record.taskId
        }
      });
    }
  },
  created: function created() {
    this.loadData();
  }
};